import { ReactNode } from 'react';

import { Theme, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { BoxProps } from '@mui/material/Box/Box';
import { styled } from '@mui/material/styles';

import { PriorityTypes } from './ActivityEvent';

export interface WrapperActivityProps extends BoxProps {
  priority: PriorityTypes;
  typeid: number;
  title: string;
  icon: ReactNode;
}

const Wrapper = styled(Box)(({ theme }: { theme: Theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '2px',
  margin: theme.spacing(0.5),
  borderRadius: '5px',
  marginBottom: '2px',
}));

const WrapperActivity = (props: Omit<WrapperActivityProps, 'typeid'>) => {
  return (
    <Wrapper {...props}>
      {props.icon}
      <Typography
        fontSize={13}
        sx={{
          ml: 0.5,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
        {props.title}
      </Typography>
    </Wrapper>
  );
};

export default WrapperActivity;
